import { PageLoader } from '@crehana/compass.ui/v2';

// https://nextjs.org/docs/app/api-reference/file-conventions/loading
const Loading = () => {
  // TODO: Replace this with a custom skeleton or loader
  return <PageLoader />;
};

export default Loading;
